import { getUnixTime, sub, Duration } from 'date-fns';

export function getPeriod(startDuration: Duration): string {
  return `${getUnixTime(sub(new Date(), startDuration))}..${getUnixTime(sub(new Date(), { seconds: 1 }))}`;
}
